import PropTypes from 'prop-types'

export const fieldConfigPropType = PropTypes.oneOfType([
  PropTypes.shape({
    accessor: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    maxLength: PropTypes.number,
    text: PropTypes.string,
    prependText: PropTypes.string
  })
])

export const fieldItemPropType = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  content: PropTypes.string,
  link: PropTypes.string,
  pubDate: PropTypes.instanceOf(Date),
  author: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.string,
  guid: PropTypes.string
})

export const sharedPropTypes = {
  item: fieldItemPropType,
  variant: PropTypes.oneOf(['card', 'list-item']),
  title: fieldConfigPropType,
  summary: fieldConfigPropType,
  body: fieldConfigPropType,
  image: fieldConfigPropType,
  footer: PropTypes.arrayOf(fieldConfigPropType),
  contentType: PropTypes.oneOf(['html', 'markdown', 'plain'])
}
